import { render, staticRenderFns } from "./CustomerAccountList.vue?vue&type=template&id=6d15a7a4&"
import script from "./CustomerAccountList.vue?vue&type=script&lang=js&"
export * from "./CustomerAccountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports